import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Col } from 'react-flexbox-grid'

import SwitchFilterSimGolf from './switch_filter_sim_golf'
import ViewFilterSimGolf from './view_filter_sim_golf'

const FiltersDektop = ({ handleChange, labelName }) => {
  return (
    <Fragment>
      <div onClick ={ handleChange }>
        <Col>
          <img className='bars' src={ require('bars_filter.svg') } />
        </Col>
        </div>
        <div className='filter_label hidden-xs' onClick ={ handleChange }>
          { !window.I18n ? '' : labelName }
        </div>
    </Fragment>
  )
}

FiltersDektop.propTypes = {
  handleChange: PropTypes.func.isRequired,
  labelName: PropTypes.string.isRequired,
}

const FiltersNonDektop = ({ handleChange, labelName }) => {
  return (
    <Fragment>
      <div onClick ={ handleChange }>
        <Col>
          <img className='bars' src={ require('bars_filter.svg') } />
        </Col>
      </div>
      <div className='filter_label hidden-xs' onClick ={ handleChange }>
        { !window.I18n ? '' : labelName }
      </div>
    </Fragment>
  )
}

FiltersNonDektop.propTypes = {
  handleChange: PropTypes.func.isRequired,
  labelName: PropTypes.string.isRequired,
}

const AdvancedFiltersSimGolf = (
  {
    disabled,
    onChange,
    onToggleAdvancedFilters,
    open,
    eventsFound,
    setListView,
    setCalendarView,
    setIsChecked,
    viewType
  }) => {
  const [dimension, setDimension] = useState(window.innerWidth)
  const [viewDisplayed, setViewDisplayed] = useState(viewType)

  useEffect(() => {
    window.addEventListener('resize', handleResize, false)
    if (dimension <= 992) {
      onChange('viewType', 'list')
      setViewDisplayed('list')
    }

    return () => window.removeEventListener('resize', handleResize, false)
  }, [])

  useEffect(() => {
    if (dimension <= 992) {
      onChange('viewType', 'list')
      setViewDisplayed('list')
    }
  }, [dimension])

  const handleResize = () => {
    setDimension(window.innerWidth)
  }

  const handleChange = () => {
    if (!disabled) {
      onToggleAdvancedFilters(!open)
    }
  }

  let labelName = open ?
    window.I18n.t('customer_directories.filters.sim_golf_advanced_filter_hide') :
    window.I18n.t('customer_directories.filters.sim_golf_advanced_filter')

  return (
    <div className='advanced_filters_sim_golf'>
      { dimension <= 992 ?
        <FiltersNonDektop
          handleChange={ handleChange }
          labelName={ labelName }
        /> :
        <FiltersDektop
          handleChange={ handleChange }
          labelName={ labelName }
        />
      }
      <span className='appearance_filters'>
        <SwitchFilterSimGolf
          switchFor='category'
          isChecked={ viewType === 'category' }
          setIsChecked={ setIsChecked }
          onChange={ onChange }
          checkedSuffix={ window.I18n.t('customer_center_comp.components.sim_golf_labels.show_by_category') }
          uncheckedSuffix={ window.I18n.t('customer_center_comp.components.sim_golf_labels.show_by_category') }
        />
        <ViewFilterSimGolf
          onChange={ onChange }
          setListView={ setListView }
          setCalendarView={ setCalendarView }
          listView={ viewDisplayed === 'list' }
          calendarView={ viewDisplayed === 'calendar' }
        />
      </span>
    </div>
  )
}

AdvancedFiltersSimGolf.propTypes = {
  open: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onToggleAdvancedFilters: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  eventsFound: PropTypes.number.isRequired,
  setListView: PropTypes.func.isRequired,
  setCalendarView: PropTypes.func.isRequired,
  setIsChecked: PropTypes.func.isRequired,
  viewType: PropTypes.string,
}

export default AdvancedFiltersSimGolf
